import type { EmbedFeedParams } from '@core/types'
import { ThumbnailShapeEnum } from '@core/types'

const STORIES_SHAPES: ReadonlySet<string> = new Set([
  ThumbnailShapeEnum.CIRCLE,
  ThumbnailShapeEnum.RECTANGLE,
  ThumbnailShapeEnum.SQUARE,
])

/**
 * Embed feed renders as stories when `thumbnail_shape` is set,
 * unless another thumbnail presentation takes precedence.
 * See docs/adr/0001-thumbnail-shape-enables-stories.md
 * @param params - Widget params
 * @returns Whether the embed feed renders as stories
 */
export function isStories(params: Partial<EmbedFeedParams>): boolean {
  if (
    params.player_deck_layout ||
    params.thumbnail_orientation === 'horizontal' ||
    params.thumbnail_style === 'dynamic'
  ) {
    return false
  }

  return !!params.thumbnail_shape && STORIES_SHAPES.has(params.thumbnail_shape)
}
